import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { awsConfig } from 'awsConfig'

const poolData = {
    UserPoolId: awsConfig.AWS_USER_POOL,
    ClientId: awsConfig.AWS_CLIEND_ID
}

export default new CognitoUserPool(poolData)
